//
// ModelDataSource.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./CodeGroup";
import "../CasResource";
import "../ExternalModel";

var ModelDataSource = createModule("BIRD::ModelDataSource", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::CodeGroup"], EventDispatcher, [
    ,
    {
        name: 7,
        casResource: 1,
        externalModel: 1,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default ModelDataSource;
